<div class="modulo modulo-form-offline">
    <div class="modulo-title">
      <h3>{{'Informe seus dados e entre em contato' | translate}}</h3>
    </div>  
    <div class="modulo-content">
      <div class="content-form">
        <form class="form form-custom" autocomplete="off" (submit)="send()"> 
          <div class="form-group">
            <label>{{'Nome' | translate}}:</label>
            <input type="text" [(ngModel)]="dataItem.nome" name="nome" uppercase />
          </div> 
          <div class="form-group">
            <label>{{'E-mail' | translate}}:</label>
            <input type="text" [(ngModel)]="dataItem.email" placeholder="nome@provedor.com" name="email" />
          </div> 
          <div class="form-group">
            <label>{{'Telefone' | translate}}:</label>
            <input type="text" [(ngModel)]="dataItem.telefone" placeholder="(**) *****-****" name="telefone" mask="(99) 99999-9999" />
          </div>
          <!--<div class="datas">  
            <div class="form-group">
              <input type="text" [(ngModel)]="dataItem.data_chegada" placeholder="Data Chegada" name="data_chegada" mask="99/99/9999" #dataChegada />
            </div> 
            <div class="form-group">
              <input type="text" [(ngModel)]="dataItem.data_partida" placeholder="Data Partida" name="data_partida" mask="99/99/9999" #dataPartida />
            </div>  
          </div>-->
          <div class="form-group">
            <input-date-range (change)="changeDates($event)"></input-date-range> 
          </div>  
          <div class="quantidade-de-passageiros">  
            <div class="header">
              <h3>{{'INFORME A QUANTIDADE DE PASSAGEIROS' | translate}}</h3>
            </div> 
            <div class="content"> 
              <div class="item">
                <label>{{'Adultos' | translate}}</label>
                <span class="info">
                  {{configuracaoLoja.passageiro_label_adt}}
                </span>
                <div class="content-input">
                  <input type="text" [(ngModel)]="dataItem.qtd_adultos" name="qtd_adultos" integer readonly />
                </div>  
                <div class="content-buttons">
                  <button type="button" class="menos btn-one" (click)="menos('adt')">
                    <span>-</span>
                  </button> 
                  <button type="button" class="mais btn-one" (click)="mais('adt')">
                    <span>+</span>
                  </button>  
                </div>
              </div>
              <div class="item">
                <label>{{'Melhor Idade' | translate}}</label>
                <span class="info">
                  {{configuracaoLoja.passageiro_label_snr}}
                </span>
                <div class="content-input">
                  <input type="text" [(ngModel)]="dataItem.qtd_melhor_idade" name="qtd_melhor_idade" integer readonly />
                </div>  
                <div class="content-buttons">
                  <button type="button" class="menos btn-one" (click)="menos('snr')">
                    <span>-</span>
                  </button> 
                  <button type="button" class="mais btn-one" (click)="mais('snr')">
                    <span>+</span>
                  </button>  
                </div>
              </div>
              <div class="item">
                <label>{{'Crianças Pagantes' | translate}}</label>
                <span class="info">
                  {{configuracaoLoja.passageiro_label_chd}}
                </span>
                <div class="content-input">
                  <input type="text" [(ngModel)]="dataItem.qtd_criancas_pagantes" name="qtd_criancas_pagantes" integer readonly />
                </div>  
                <div class="content-buttons">
                  <button type="button" class="menos btn-one" (click)="menos('chd')">
                    <span>-</span>
                  </button> 
                  <button type="button" class="mais btn-one" (click)="mais('chd')">
                    <span>+</span>
                  </button>  
                </div>
              </div>
              <div class="item">
                <label>{{'Crianças Cortesia' | translate}}</label>
                <span class="info">
                  {{configuracaoLoja.passageiro_label_chd_free}}
                </span>
                <div class="content-input">
                  <input type="text" [(ngModel)]="dataItem.qtd_criancas_cortesia" name="qtd_criancas_cortesia" integer readonly />
                </div>  
                <div class="content-buttons">
                  <button type="button" class="menos btn-one" (click)="menos('inf')">
                    <span>-</span>
                  </button> 
                  <button type="button" class="mais btn-one" (click)="mais('inf')">
                    <span>+</span> 
                  </button>  
                </div>
              </div>  
            </div>  
          </div> 
          <div class="form-group">  
            <label>{{'Escreva sua dúvida' | translate}}:</label>
            <textarea rows="5" [(ngModel)]="dataItem.mensagem" placeholder="{{'Escreva o que você precisa aqui. Logo entraremos em contato.' | translate}}" name="mensagem"></textarea>
          </div>  
          <div class="form-group">
            <div class="form-footer">
              <button type="submit" class="btn-two btn-icon btn-send">
                <i class="material-icons">forward_to_inbox</i>
                <span>{{'Enviar' | translate}}</span>
              </button>  
            </div>  
          </div>  
        </form>  
      </div>
    </div>  
  </div>
 <loader [message]="messageLoader" [hidden]="!loader"></loader>
  